/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useContext, useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {getSettings, updatePoliciesSettings} from '../list/core/_requests'
import {Button, Modal} from 'react-bootstrap'
import {AlertContext} from '../../../../../_metronic/layout/components/alert-context'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

export function ViewAppPolicies() {
  const {showAlert} = useContext(AlertContext)
  const location = useLocation()
  const navigate = useNavigate()
  const [data, setData] = useState<any>([])
  const [showModal, setShow] = useState(false)
  const [terms, setTerms] = useState('')
  const [privacy, setPrivacy] = useState('')
  const [refund, setRefund] = useState('')
  const [about, setAbout] = useState('')

  const handleClose = () => setShow(false)

  useEffect(() => {
    getInitialValues()
  }, [showModal])

  const getInitialValues = () => {
    getSettings().then((res: any) => {
      const settingsData = res.data?.data[0]
      setData(settingsData)
      setTerms(settingsData?.terms_and_condition || '')
      setPrivacy(settingsData?.privacy_policy || '')
      setRefund(settingsData?.refund_policy || '')
      setAbout(settingsData?.about_us || '')
    })
  }

  const handleEdit = () => {
    setShow(true)
  }

  const SubmitHandle = () => {
    const datas = {
      id: data?.id,
      terms_and_condition: terms,
      privacy_policy: privacy,
      refund_policy: refund,
      about_us: about,
    }

    updatePoliciesSettings(datas).then((res) => {
      showAlert(res?.data?.Message, res?.data?.Code)
      getInitialValues()
      navigate('/settings/appPolicies', {replace: true})
    }).catch(err => {
      showAlert('Failed to update policies', '0')
    })

    setShow(false)
  }

  return (
    <>
      <div className='tab-content' id='myTabContent'>
        <div className='mb-xl-10 tab-pane fade active show' id='kt_tab_overview' role='tabpanel'>
          <div className='card mb-5 mb-xl-10'>
            <div className='card-header cursor-pointer'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>App Policies Details</h3>
              </div>
              <button onClick={handleEdit} className='btn btn-primary align-self-center'>
                Edit
              </button>
            </div>

            <div className='card-body p-9'>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Terms & Conditions</label>
                <div className='col-lg-8'>
                  <div
                    className='fw-bolder fs-6 text-dark bg-light p-4 rounded'
                    style={{maxHeight: '200px', overflowY: 'auto'}}
                    dangerouslySetInnerHTML={{__html: data?.terms_and_condition || 'Not set'}}
                  ></div>
                </div>
              </div>
              
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Privacy Policy</label>
                <div className='col-lg-8'>
                  <div
                    className='fw-bolder fs-6 text-dark bg-light p-4 rounded'
                    style={{maxHeight: '200px', overflowY: 'auto'}}
                    dangerouslySetInnerHTML={{__html: data?.privacy_policy || 'Not set'}}
                  ></div>
                </div>
              </div>
              
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Refund Policy</label>
                <div className='col-lg-8'>
                  <div
                    className='fw-bolder fs-6 text-dark bg-light p-4 rounded'
                    style={{maxHeight: '200px', overflowY: 'auto'}}
                    dangerouslySetInnerHTML={{__html: data?.refund_policy || 'Not set'}}
                  ></div>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>About Us</label>
                <div className='col-lg-8'>
                  <div
                    className='fw-bolder fs-6 text-dark bg-light p-4 rounded'
                    style={{maxHeight: '200px', overflowY: 'auto'}}
                    dangerouslySetInnerHTML={{__html: data?.about_us || 'Not set'}}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Modal show={showModal} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Update Policies</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row mb-7'>
            <label className='col-lg-12 fw-bold text-muted mb-2'>Terms & Conditions</label>
            <div className='col-lg-12'>
              <ReactQuill theme="snow" value={terms} onChange={setTerms} style={{height: '200px', marginBottom: '50px'}} />
            </div>
          </div>
          
          <div className='row mb-7'>
            <label className='col-lg-12 fw-bold text-muted mb-2'>Privacy Policy</label>
            <div className='col-lg-12'>
              <ReactQuill theme="snow" value={privacy} onChange={setPrivacy} style={{height: '200px', marginBottom: '50px'}} />
            </div>
          </div>
          
          <div className='row mb-7'>
            <label className='col-lg-12 fw-bold text-muted mb-2'>Refund Policy</label>
            <div className='col-lg-12'>
              <ReactQuill theme="snow" value={refund} onChange={setRefund} style={{height: '200px', marginBottom: '50px'}} />
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-12 fw-bold text-muted mb-2'>About Us</label>
            <div className='col-lg-12'>
              <ReactQuill theme="snow" value={about} onChange={setAbout} style={{height: '200px', marginBottom: '50px'}} />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
          <Button variant='primary' onClick={SubmitHandle}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
